var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-status-chip"},[_c('label',{class:{
      active:
        _vm.status.toFriendlyStatus() == 'Active' ||
        _vm.status.toFriendlyStatus() == 'Printed' ||
        _vm.status.toFriendlyStatus() == 'In Stock' ||
        _vm.status.toFriendlyStatus() == 'Awaiting Receipt' ||
        _vm.status.toFriendlyStatus() == 'Awaiting Production' ||
        _vm.status.toLocaleLowerCase() == 'success' ||
        _vm.status.toFriendlyStatus() == 'Issued' ||
        _vm.status.toFriendlyStatus() == 'Available',
      outofstock: _vm.status.toFriendlyStatus() == 'Out of Stock',
      inProgess: _vm.status.toFriendlyStatus() == 'In Progress',
      approved: _vm.status.toFriendlyStatus() == 'Approved',
      completed:
        _vm.status.toFriendlyStatus() == 'Completed' ||
        _vm.status.toFriendlyStatus() == 'Complete' ||
        _vm.status.toFriendlyStatus() == 'Invoiced' ||
        _vm.status == 'Complete' ||
        _vm.status == 'Complete' ||
        _vm.status == 'Refunded' ||
        _vm.status == 'Committed',
      cancelled:
        _vm.status.toFriendlyStatus() == 'Cancelled' ||
        _vm.status.toFriendlyStatus() == 'Credit Hold' ||
        _vm.status.toFriendlyStatus() == 'Closed' ||
        _vm.status.toFriendlyStatus() == 'Cash Before Despatch' ||
        _vm.status.toFriendlyStatus() == 'Inactive' ||
        _vm.status == 'Reversed',
      draft:
        _vm.status.toFriendlyStatus() == 'Draft' ||
        _vm.status == 'Prepared' ||
        _vm.status == 'Reversal',
      pending:
        _vm.status.toFriendlyStatus() == 'Pending' ||
        _vm.status.toFriendlyStatus() == 'Reserved',
      locked:
        _vm.status.toFriendlyStatus() == 'Locked' ||
        _vm.status.toFriendlyStatus() == 'Assigned',
      enquiry:
        _vm.status.toFriendlyStatus() == 'Enquiry' ||
        _vm.status.toFriendlyStatus() == 'Accepted',
      new:
        _vm.status.toFriendlyStatus() == 'New' ||
        _vm.status.toFriendlyStatus() == 'Edit',
      open: _vm.status.toFriendlyStatus() == 'Open' || _vm.status == 'Open',
      paid: _vm.status.toFriendlyStatus() == 'Paid',
      overdue: _vm.status.toFriendlyStatus() == 'Overdue',
      credited: _vm.status.toFriendlyStatus() == 'Credited',
      credit: _vm.status.toFriendlyStatus() == 'Credit',
      allocated:
        _vm.status.toFriendlyStatus() == 'Allocated' ||
        _vm.status.toFriendlyStatus() == 'Committed with Errors' ||
        _vm.status.toFriendlyStatus() == 'Offered' ||
        _vm.status.toFriendlyStatus() == 'Investigating',
      unallocated:
        _vm.status.toFriendlyStatus() == 'Unallocated' ||
        _vm.status.toFriendlyStatus() == 'On Hold',
      reconciled: _vm.status.toFriendlyStatus() == 'Reconciled',
      unpresented:
        _vm.status.toFriendlyStatus() == 'Unpresented' ||
        _vm.status.toFriendlyStatus() == 'Uncommitted Reconciliation',
      pendingInvoice: _vm.status.toFriendlyStatus() == 'Pending Invoice',
      failed:
        _vm.status.toFriendlyStatus() == 'FAILED' ||
        _vm.status.toFriendlyStatus() == 'Failed',
      queued:
        _vm.status.toFriendlyStatus() == 'QUEUED' ||
        _vm.status.toFriendlyStatus() == 'Queued' ||
        _vm.status.toFriendlyStatus() == 'Partially Received',
      onhold: _vm.status.toFriendlyStatus() == 'On Hold',
      sent:
        _vm.status.toFriendlyStatus() == 'SENT' ||
        _vm.status.toFriendlyStatus() == 'Resolved' ||
        _vm.status.toFriendlyStatus() == 'Sent',
      compliant: _vm.status.toFriendlyStatus() == 'Compliant',
      notCompliant: _vm.status.toFriendlyStatus() == 'Not Compliant',
      incomplete:
        _vm.status.toFriendlyStatus() == 'Incomplete' ||
        _vm.status.toFriendlyStatus() == 'Not Reconciled',
      notified: _vm.status == 'Notified',
      return:
        _vm.status.toFriendlyStatus() == 'Return' ||
        _vm.status.toFriendlyStatus() == 'Returned',
      inproduction:
        _vm.status.toFriendlyStatus() == 'In Production' ||
        _vm.status.toFriendlyStatus() == 'Not Booked',
      planned:
        _vm.status.toFriendlyStatus() == 'Planned' ||
        _vm.status.toFriendlyStatus() == 'Confirmed',
      awaitingPlanning:
        _vm.status.toFriendlyStatus() == 'Awaiting Planning' ||
        _vm.status.toFriendlyStatus() == 'Requested',
      planning: _vm.status.toFriendlyStatus() == 'Planning',
      review: _vm.status.toFriendlyStatus() == 'Review',
    },style:({
      'background-color': _vm.customBackGroundColor(_vm.data),
    })},[_vm._v(_vm._s(_vm.status.toFriendlyStatus()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }